import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ActualDateChange } from '../../shared/misc-classes';
import { DataService } from '../../shared/dataservice.service';

@Component({
  selector: 'actual-date-dialog',
  templateUrl: 'actual-date-dialog.html',
  styleUrls: ['./actual-date-dialog.css']
  //changeDetection:ChangeDetectionStrategy.OnPush
})
export class ActualDateDialog {
  Hvr: any = {};
  errorMessage: string = '';
  constructor(
    public _dataService:DataService,
    public dialogRef: MatDialogRef<ActualDateDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ActualDateChange) {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getAddCommentLabel() {
    if (this.data.plannedDate && this.data.actualDate) {
      if (this.data.actualDate > this.data.plannedDate) {
        return "Reason for Delay *";
      }
    }
    return "Additional Info";
  }
  confirmClick() {
    this.errorMessage = '';
    if (this.data.plannedDate && this.data.actualDate) {
      if (this.data.actualDate > this.data.plannedDate) {
        if (this.data.comments == null || this.data.comments == '') {
          this.errorMessage = '* Please Enter Reason for Delay';
          return;
        }
      }
    }
    this.dialogRef.close(true);
  }
}